import { ID } from "@/api/Charities"
import Image from "next/image"
import Link from "next/link"
import Marquee, { MarqueeProps } from "react-fast-marquee"

const ImagesMarquee: React.FC<MarqueeProps & { imgSrcList: { src: string; name: string; slug: string; id: ID }[] }> = ({
  imgSrcList: list,
  ...marqueeProps
}) => {
  return (
    <Marquee {...marqueeProps}>
      {list.map(({ src, name, slug, id }, index) => (
        <div key={index + slug + id}>
          {!!src && (
            <Link href={`/goede-doelen/${slug || id}`}>
              <Image src={src} height="40" width="100" alt={name} title={name} className="m-8" />
            </Link>
          )}
        </div>
      ))}
    </Marquee>
  )
}

export default ImagesMarquee
